<template>
  <svg
    :viewBox="`0 0 ${viewBox} ${viewBox}`"
    :height="size"
    :width="size"
  >
    <path
      :fill="color !== 'primary' ? color : $vuetify.theme.themes.light.primary "
      :d="iconCode"
    />
  </svg>
</template>

<script>
/* eslint-disable */
import { Component, Vue, Watch } from 'vue-property-decorator'
import icons from '@/resources/json/icons.json'

@Component({
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String
    },
    viewBox: {
      type: Number,
      default: 24
    },
    size: {
      type: Number,
      default: 25
    }
  }
})
export default class Icon extends Vue {
  data () {
    return {
      icons: icons,
      iconCode: ''
    }
  }

  mounted () {
    this.getIcon()
  }

  @Watch('icon')
  getIcon() {}

  getIcon () {
    const icon =  this.icons.find((item) => item.name === this.icon)

    if (icon) {
      this.iconCode = icon.code
    }
  }
}
</script>